


































































































import { Component, Watch } from "vue-property-decorator";
import { Getter } from "vuex-class";
import { mixins } from "vue-class-component";
import { FeedbackDto, LanguageDto } from "@/server/app.dtos";
import SideComponent from "@/models/shared/side.component";
import { LayoutServiceBus } from "@/services/bus/layout.service";
import { FeedbackService } from "@/services/api/feedback.service";
import { UsersService } from "@/services/api/users.service";
import MenuList from "./shared/MenuList.vue";
import {
  ServerGrid,
  DataServerGridOptions
} from "@/components/mixins/ServerGridMixins";

import {
  GetFeedbackDtosQuery,
  GetFeedbacksDtosIncludeOptions
} from "@/server/app.queries";
import { ListResponse } from "@/models/grids/list.response";

@Component({
  components: {
    LeftMenu: MenuList
  }
})
export default class FeedbackListPage extends mixins(ServerGrid) {
  @Getter("currentLanguage") currentLanguage!: LanguageDto;
  @Watch("$route", { deep: true })
  onRouteChange() {
    this.Load();
  }
  feedbackService: FeedbackService = new FeedbackService();
  usersService: UsersService = new UsersService();
  photoSrc: string = ""

  constructor() {
    super();
    this.gridConfigs = new DataServerGridOptions();
  }

  getProfilePhotoSrc(path:string) {
    return this.usersService.GetProfilePhotoSrc(path);
  }

  initials(user:any){
    return user?.name?.substring(0, 2).toUpperCase() || ""
  }

  async created() {
    this.gridConfigs.columns = [
      {
        text: "Tipo",
        value: "feedbackType.title",
        filterable: false,
        align: "center",
        sortable: true
      },
      {
        text: "Designação",
        value: "title",
        filterable: true,
        sortable: true
      },
      {
        text: "Data de Inicio",
        value: "dateStart",
        filterable: false,
        sortable: true
      },
      {
        text: "Data de Fim",
        value: "dateEnd",
        filterable: false,
        sortable: true
      },
      {
        text: "Estado",
        value: "resolved",
        filterable: false,
        sortable: false
      },
      {
        text: "Responsavel",
        value: "user.photo",
        filterable: false,
        sortable: false
      },
      {
        text: "Ações",
        value: "idFeedback",
        filterable: false,
        sortable: false
      }
    ];
    this.GridInit();
    await this.Load();
  }

  async Load() {
    const request = new GetFeedbackDtosQuery();
    request.init(this.$route.query);
    request.includes = new GetFeedbacksDtosIncludeOptions();
    request.includes.feedbackType = true;
    request.includes.user= true;
    
    if (!request.take || request.take <= 0) {
      request.skip = 0;
      request.take = this.gridConfigs.pageSize;
    }
    this.GridSetLoading(true);
    await this.feedbackService
      .GetList(request)
      .then((result: ListResponse<FeedbackDto>) => {this.GridLoad(result)})
      .catch((error: any) => console.log(error))
      .finally(() => this.GridSetLoading(false));
  }

  viewFeedback(feedback: FeedbackDto): void {
    const comp = new SideComponent();
    comp.title = "DetailFeedbackSideMenuComponent";
    comp.args = {
      feedback: feedback
    };
    LayoutServiceBus.openSideMenu(comp);
  }

  createFeedback(): void {
    const comp = new SideComponent();
    comp.title = "CreateFeedbackSideMenuComponent";
    comp.args = {};
    LayoutServiceBus.openSideMenu(comp);
  }
}
